import React from 'react'
import { useTranslation } from 'react-i18next'
import { useForm, Controller } from 'react-hook-form'
import HexagonBackground from 'layouts/HexagonsBackground'
import RegisterLayout from 'layouts/RegisterLayout'
import wizzflixLogo from 'assets/images/logo.png'
import { CustomInput } from 'modules/common/components/Input'
import MainLogo from 'modules/common/components/Logo'
import { Form, FormItem } from 'modules/common/components/Form'
import { HexagonButton } from 'modules/common/components/Buttons/HexagonBtn'
import { LogoWrapper, ButtonWrapper, Error, Text, ORText, TextWrapper, EmptyLine } from './styles'
import { SerializedError } from '@reduxjs/toolkit'
import { useBrandingColors } from 'hooks/useBrandingColors'
import ContinueWith from 'modules/common/components/ContinueWith'
import { AuthRoutes } from 'router/routesConfig'
import { PhoneSvg } from 'assets/svg'

type FormData = {
  email: string
}

interface IProps {
  handleFormSubmit: (email: string) => void
  asyncError: SerializedError | null
}

const Email: React.FC<IProps> = ({ handleFormSubmit, asyncError }) => {
  const { t } = useTranslation()
  const { icon, text } = useBrandingColors()

  const {
    handleSubmit,
    errors,
    control,
    formState: { isValid, isSubmitting },
  } = useForm<FormData>({
    defaultValues: {
      email: '',
    },
    mode: 'onChange',
  })

  const onSubmit = handleSubmit(({ email }) => {
    handleFormSubmit(email)
  })

  return (
    <HexagonBackground>
      <RegisterLayout>
        <LogoWrapper>
          <MainLogo logo={wizzflixLogo} />
        </LogoWrapper>
        <TextWrapper>
          <Text>{t('AUTH_MODULE.FILL_IN_EMAIL')}</Text>
          <EmptyLine>_</EmptyLine>
        </TextWrapper>

        <Form onSubmit={onSubmit} noValidate>
          <FormItem>
            <Controller
              name="email"
              control={control}
              rules={{ required: 'Required' }}
              as={
                <CustomInput
                  hasError={!!errors.email || !!asyncError}
                  placeholder={t('AUTH_MODULE.EMAIL_PLACEHOLDER')}
                  textColor={text}
                  type="text"
                  autoComplete="off"
                />
              }
            />
          </FormItem>

          <ButtonWrapper>
            <HexagonButton
              onClick={onSubmit}
              isActive={isValid && !isSubmitting}
              startColor="#fff"
              endColor="#fff"
              arrowColor={icon}
            />
          </ButtonWrapper>
          {asyncError && asyncError.message && <Error>{asyncError.message}</Error>}
          <ORText>{t('AUTH_MODULE.OR')}</ORText>
          <ContinueWith
            text={t('AUTH_MODULE.CONTINUE_PHONE')}
            redirect={AuthRoutes.PHONE}
            icon={<PhoneSvg />}
          />
        </Form>
      </RegisterLayout>
    </HexagonBackground>
  )
}

export default Email
